import { render, staticRenderFns } from "./CustomFloatAvatar copy.vue?vue&type=template&id=24a49158&scoped=true"
import script from "./CustomFloatAvatar copy.vue?vue&type=script&lang=js"
export * from "./CustomFloatAvatar copy.vue?vue&type=script&lang=js"
import style0 from "./CustomFloatAvatar copy.vue?vue&type=style&index=0&id=24a49158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a49158",
  null
  
)

export default component.exports